// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"b9b57ef3","221":"79de1aad","497":"32c68293","617":"e6c85d47","638":"586f3680","752":"ae0a85be","780":"496e8bb2","859":"d6ae4a1d"}[chunkId] + ".chunk.css";
};